import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@klaro7/ui';

import { CallHistory } from '@/features/calls/components/CallHistory';

export function CallHistoryPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle>Le mie chiamate</CardTitle>
          <CardDescription>Storico delle tue consulenze telefoniche e videochiamate</CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <CallHistory />
        </CardContent>
      </Card>
    </div>
  );
}
